<div class="company-container" *ngIf="!loading">
  <div class="inner-container">

    <div class="box-container mr-btn-16">
      <p class="title mr-btn-40">Tipo de mercado</p>
      <div class="toggle-box">
        <p>Mercado primário</p>
        <mat-slide-toggle id="primary-market-toggle" [(ngModel)]="companyInfo.market_type.primary_market"></mat-slide-toggle>
      </div>
      <div class="toggle-box">
        <div>
          <p>Mercado secundário</p>
          <div class="checkbox-box" *ngIf="companyInfo.market_type.secondary_market">
            <lib-input-checkbox [(ngModel)]="companyInfo.market_type.sale" id="sale-market-checkbox" name="sale" label="Venda"></lib-input-checkbox>
            <lib-input-checkbox [(ngModel)]="companyInfo.market_type.rent" id="rental-market-checkbox" name="rental" label="Locação"></lib-input-checkbox>
          </div>
         </div>   
        <mat-slide-toggle id="secondary-market-toggle" (change)="changeSecondaryMarket($event)" [(ngModel)]="companyInfo.market_type.secondary_market"></mat-slide-toggle>
      </div>

      <div class="disqualification-container">
        <p class="title">Gestão de produto em caso de descredencimento</p>
        <p class="description">Definir para quem irá a gestão do produto em caso de descreencimento do antigo gestor (apenas mercado secundário)</p>
        <div class="dropdown-box">
          <app-dropdown-button id="dropdown-disqualification" 
          [label]="getMarketProdutName()"
          [(isOpen)]="marketDropdown"
          (valueChange)="marketDropdown = $event"> 
            <ul class="dropdown-text-list">
              <div *ngFor="let item of disqualificationList; let i = index">
                <li id="disqualification-dropdown-{{i}}" (click)="item.func() ; marketDropdown = false">{{item.label}}</li>
              </div>
            </ul>
          </app-dropdown-button>
        </div>
      </div>
    </div>

    <div class="box-container mr-btn-16">
      <p class="title mr-btn-16">Alertas de novos leads</p>
      <p class="description">Definir quem recebe alertas de novos leads e o período que os alertas podem ser recebidos</p>

      <div *ngFor="let lead of companyInfo.new_lead_alert; let i = index; let last = last">
        <div class="dropdown-tags">
          <p class="description">Quem recebe alerta de novo lead</p>
          <app-dropdown-tags
            id="new-leads-tags-{{i}}"
            [disabled]="false" 
            [tags]="getTags(lead.destinataries)" 
            (removeTag)="removeTags($event, lead)">
            <div class="dropdown-tags-box">
              <div class="tags">
                <lib-input-checkbox id="ownuser-chackbox" [(ngModel)]="lead.own_user" (click)="selectCheckbox(lead, lead.own_user, 'OWN_USER')" label="Próprio usuário"></lib-input-checkbox>
                <lib-input-checkbox id="leaderuser-chackbox" [(ngModel)]="lead.leader_user" (click)="selectCheckbox(lead, lead.leader_user, 'IMMEDIATE_LEADER')" label="Líder imediato"></lib-input-checkbox>
                <span class="other-user" (click)="findUser(lead)">Outro usuário</span>
              </div>
            </div>
          </app-dropdown-tags>
        </div>
        <div class="alerts-period">
          <div class="row">
            <div class="timer-container">
              <p class="mr-btn-8">Período de alertas</p>
              <div class="timer-line">
                <app-timepicker   
                  id="new-lead-from-timepicker"
                  [(ngModel)]="lead.initial_time"
                  [placeholder]="'de'" 
                  (selectValue)="lead.initial_time = $event"
                  >
                </app-timepicker>
                <p>Até</p>
                <app-timepicker  
                  id="new-lead-to-timepicker"  
                  [(ngModel)]="lead.final_time"
                  [placeholder]="'até'" 
                  (selectValue)="lead.final_time = $event"
                  >
                </app-timepicker>
              </div>         
            </div>    
          </div>  
          <p id="new-lead-exclud-btn" *ngIf="companyInfo.new_lead_alert.length > 1" class="exlude-label" (click)="removeNewLead(i)">Excluir alerta</p> 
        </div>
        <div class="bottom-add-btn">
          <p id="new-lead-alert-btn" *ngIf="last" class="new-alert" (click)="addNewLead()">Novo alerta</p>
        </div> 
      </div>

    </div>

    <div class="box-container">
      <p class="title mr-btn-16">Alertas leads não atendidos</p>
      <p class="description">Definir quem recebe alertas de leads não atendidos e o período que os alertas podem ser recebidos</p>

      <div *ngFor="let lead of companyInfo.unattended_lead_alert; let i = index; let last = last">
        <div class="dropdown-tags">
          <p class="description">Quem recebe alerta de leads não atendidos</p>
          <app-dropdown-tags
            id="notmet-leads-tags-{{i}}"
            [disabled]="false" 
            [tags]="getTags(lead.destinataries)" 
            (removeTag)="removeTags($event, lead)">
            <div class="dropdown-tags-box">
              <div class="tags">
                <lib-input-checkbox id="ownuser-chackbox" [(ngModel)]="lead.own_user" (click)="selectCheckbox(lead, lead.own_user, 'OWN_USER')" label="Próprio usuário"></lib-input-checkbox>
                <lib-input-checkbox id="leaderuser-chackbox" [(ngModel)]="lead.leader_user" (click)="selectCheckbox(lead, lead.leader_user, 'IMMEDIATE_LEADER')" label="Líder imediato"></lib-input-checkbox>
                <span class="other-user" (click)="findUser(lead, true)">Outro usuário</span>
              </div>
            </div>
          </app-dropdown-tags>
        </div>
        <div class="alerts-period">
          <div class="row">
            <div class="alert-time">
              <p class="mr-btn-8">Tempo do alerta</p>
              <app-dropdown-input-list
                id="alert-time-dropdown-input"
                [list]="returnInList"
                [label]="(lead.time_alert_value && lead.time_type) ? formatReturnIn({name: lead.time_type, value: lead.time_alert_value}) : 'Tempo'"
                [currentValue]="{value: lead.time_alert_value, name: lead.time_type}"
                (valueChange)="lead.time_type = $event.name ; lead.time_alert_value = $event.value"
                (cleanValue)="lead.time_alert_value = ''"
              >
              </app-dropdown-input-list>
            </div>
            <div class="timer-container">
              <p class="mr-btn-8">Período de alertas</p>
              <div class="timer-line">
                <app-timepicker    
                  id="no-lead-from-timepicker" 
                  [(ngModel)]="lead.initial_time"
                  [placeholder]="'de'" 
                  (selectValue)="lead.initial_time = $event"
                  >
                </app-timepicker>
                <p>Até</p>
                <app-timepicker   
                  id="no-lead-to-timepicker" 
                  [(ngModel)]="lead.final_time"
                  [placeholder]="'até'" 
                  (selectValue)="lead.final_time = $event"
                  >
                </app-timepicker>
              </div>         
            </div>    
          </div>  
          <p id="no-lead-exclud-btn" *ngIf="companyInfo.unattended_lead_alert.length > 1" class="exlude-label" (click)="removeNewLeadNotMet(i)">Excluir alerta</p> 
        </div>
        <div class="bottom-add-btn">
          <p id="no-lead-alert-btn" *ngIf="last" class="new-alert" (click)="addNewLeadNotMet()">Novo alerta</p>
        </div> 
      </div>

    </div>
    <div class="footer-action">
      <lib-button-tertiary id="cancel-btn" (click)="navigatoBack()">Cancelar</lib-button-tertiary>
      <lib-button-primary id="save-btn" (click)="save()">Salvar</lib-button-primary>
    </div>
  </div>
</div>

<app-user-modal *ngIf="showUserModal" [companyId]="companyInfo.company_id" (closeModal)="showUserModal = false" (saveModal)="selectUser($event)"></app-user-modal>
